export default async function ProductCard({ product, variant, scope = null }) {
  const res = await fetch(
    `/products/${product.handle}?view=card${
      variant ? `&variant=${variant}` : ""
    }`
  );

  const wrapper = document.createElement("div");
  wrapper.innerHTML = await res.text();

  return wrapper.innerHTML;
}
